<template>
  <div class="login-nav">
    <div class="login-main">
      <img
        v-if="VUE_APP_VERSION == 'hprt'"
        class="left-img1 here-logo"
        src="../../assets/here/here-logo.png"
        alt=""
      />
      <img v-else class="left-img1" src="../../assets/logo.png" alt="" />
      <div class="login-content">
        <div class="login-left loginPic"></div>
        <div class="login-right">
          <div class="login-title">{{ $t(`label.label45`) }}</div>
          <a-form
            ref="formRef"
            :model="formState"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-item name="account">
              <a-input
                @input="accountInput"
                :class="errArray.errAccount ? 'errStyle' : ''"
                v-model:value="formState.account"
                @keyup.enter="onSubmit"
                :placeholder="
                  VUE_APP_VERSION == 'hereLabelTop' ? $t(`tips.tip13`) : $t(`tips.tip7`)
                "
              />
            </a-form-item>
            <a-form-item name="password">
              <a-input-password
                @keyup.enter="onSubmit"
                :class="errArray.errPassword ? 'errStyle' : ''"
                v-model:value="formState.password"
                :placeholder="$t(`tips.tip11`)"
                autocomplete="off"
              />
            </a-form-item>
          </a-form>
          <div>
            <span class="forget-text" @click="handleClickUrl(3)">{{
              $t(`button.forgetPass`)
            }}</span>
          </div>

          <div class="login-btn">
            <a-button @click="onSubmit">{{ $t(`button.login`) }}</a-button>
          </div>
          <div class="check-box">
            <a-checkbox v-model:checked="checked" @change="readChange"></a-checkbox>
            {{ $t(`label.label47`)
            }}<span
              style="color: #003591; cursor: pointer"
              @click="handleOpenAgreement(0)"
              >{{ $t(`label.label48`) }}</span
            >{{ $t(`label.label49`)
            }}<span
              style="color: #003591; cursor: pointer"
              @click="handleOpenAgreement(1)"
              >{{ $t(`label.label50`) }}</span
            >
          </div>
          <div class="login-method" v-if="VUE_APP_VERSION != 'hereLabelTop'">
            <a-divider>{{ $t(`label.label62`) }}</a-divider>
            <div class="method-box">
              <div
                class="method-item"
                v-for="(item, index) in thirdLogin"
                :key="index"
                @click="handleMoreLogin(item.type)"
              >
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <div class="no-accout">
            {{ $t(`tips.tip32`) }}
            <span style="color: #003591; cursor: pointer" @click="handleClickUrl(0)">{{
              $t(`button.goRegister`)
            }}</span>
            <a-divider type="vertical" style="border-left: 1px solid #d6dce6"></a-divider>
            <span style="color: #003591; cursor: pointer" @click="handleClickUrl(1)">{{
              $t(`button.help`)
            }}</span>
            <a-divider type="vertical" style="border-left: 1px solid #d6dce6"></a-divider>
            <span @click="handleClickUrl(2)" style="color: #003591; cursor: pointer">{{
              $t(`button.downloadPC`)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="beihao" v-if="VUE_APP_VERSION != 'hereLabelTop'">
      Xiamen Hanin Co.,Ltd. ALL RIGHTS RESERVED. ©2016-{{ new Date().getFullYear() }}
      <a
        v-if="VUE_APP_VERSION == 'hprt'"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >闽ICP备17017244号-2</a
      >
      <a v-else href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
        >闽ICP备17017244号-5</a
      >
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { validateAccount, validateMobilePhone } from "@/utils/validate";
import { setAuthorization, getAuthorization, checkAuthorization } from "@/utils/request";
import { message } from "ant-design-vue";
import { getSign } from "@/utils/signature";

import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  toRefs,
  watch,
} from "vue";

export default defineComponent({
  setup() {
    const router = useRouter();

    let globalProperties = getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;
    const { proxy } = getCurrentInstance();
    const state = reactive({
      formRef: null,
      errArray: {
        errAccount: false,
        errPassword: false,
      },
      formState: {
        account: "",
        password: "",
      },
      rules: {
        account: {
          required: true,
          validator: validateAccount,
          trigger: "change",
        },
        password: {
          required: true,
          message: proxy.$t(`tips.tip11`),
        },
      },
      checked: true,
      textTime: null,
      language: proxy.$i18n.locale,
      thirdLogin: [
        {
          img: require("../../../static/icon/wechat.png"),
          type: "wechat",
        },
        {
          img: require("../../../static/icon/qq.png"),
          type: "qq",
        },
        // {
        //   img: require("../../../static/icon/google.png"),
        //   type: "google",
        // },
        // {
        //   img: require("../../../static/icon/facebook.png"),
        //   type: "facebook",
        // },
        // {
        //   img: require("../../../static/icon/apple.png"),
        //   type: "apple",
        // },
      ],
      codeTimer: null,
      appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
      appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
    });
    onMounted(() => {});
    //监听language的变化
    watch(
      () => proxy.$i18n.locale,
      () => {
        state.language = proxy.$i18n.locale;
      }
    );

    //打开隐私协议
    const handleOpenAgreement = (val) => {
      let lang = state.language == "zh" ? "zh" : "en";
      if (val == 0) {
        window.open(`https://hm.hprt.com/hmapp/protocol.html?id=1&lang=${lang}`);
      } else if (val == 1) {
        window.open(`https://hm.hprt.com/hmapp/protocol.html?id=4&lang=${lang}`);
      }
    };

    //第三方登录
    const handleMoreLogin = (type) => {
      // getOpenId(1, "031SPy0w3TSn113PHE0w3HwaYm3SPy0X");
      // getOpenId(2, "8BE5ED701DF8114719736792561C2C63");
      // return
      let third_type = "";
      var features =
        "width=600,height=550, top=150, left=150, toolbar=no, menubar=no, scrollbars=no, status=no";

      if (state.VUE_APP_VERSION == "hprt") {
        var redirect_uri = "https://hm.hprt.com/label/ThirdLogin";
      } else {
        var redirect_uri = "https://labeldesigner.idprt.com/ThirdLogin";
      }
      switch (type) {
        case "wechat":
          if (state.VUE_APP_VERSION == "hprt") {
            var appid = "wx668bb3b1a0723789";
          } else {
            var appid = "wx21603b0ceff35dcb";
          }
          var url =
            "https://open.weixin.qq.com/connect/qrconnect?appid=" +
            appid +
            "&redirect_uri=" +
            redirect_uri +
            "&response_type=code&scope=snsapi_login&state=hm_md_wx#wechat_redirect";
          third_type = 1;
          break;
        case "qq":
          if (state.VUE_APP_VERSION == "hprt") {
            var client_id = "102020209";
          } else {
            var client_id = "102005410";
          }
          var url =
            "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" +
            client_id +
            "&redirect_uri=" +
            redirect_uri +
            "&response_type=code";
          third_type = 2;
          break;
        // case "google":
        //   var url =
        //     "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=1087549668288-8n0nni7b8tshk6v9qj15e9mgkf7uj57e.apps.googleusercontent.com&redirect_uri=http://hm.cn/portal/third_party/getCodeOp&scope=profile&response_type=code";
        //   third_type = 3;
        //   break;
        // case "facebook":
        //   FB.getLoginStatus(function(response) {
        //     statusChangeCallback(response);
        //   });
        //   var url =
        //     "https://www.facebook.com/v10.0/dialog/oauth?client_id={app-id}&redirect_uri={redirect-uri}&scope=profile&response_type=code";
        //   third_type = 4;
        //   break;
        // case "apple":
        //   var url =
        //     "https://appleid.apple.com/auth/authorize?client_id=com.PRT.HMark.Web&redirect_uri=https://labeldesigner.idprt.com/&scope=email+name&response_type=code&response_mode=form_post";

        //   third_type = 5;
        //   break;
      }
      window.open(url, "newwin", features);

      state.codeTimer = setInterval(() => {
        let code = localStorage.getItem("code");
        if (code) {
          clearInterval(state.codeTimer);
          getOpenId(third_type, code);
          localStorage.removeItem("code");
        }
      }, 1000);
    };

    //获取第三方openid
    const getOpenId = (third_type, code) => {
      if (state.VUE_APP_VERSION == "hprt") {
        var verify_type = 6;
      } else {
        var verify_type = 1;
      }
      let param = {
        timestamp: Date.parse(new Date()) / 1000,
        fun: "getThirdOpenid",
        requestType: "User",
        appId: state.appId,
        appKey: state.appKey,
        third_type: third_type,
        verify_type: verify_type,
        code: code,
      };
      var signature = getSign(param);
      var obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj)
        .then((res) => {
          let openid = res.openid;
          verifyLogin(openid, third_type);
        })
        .catch((err) => {});
    };

    //验证第三方登录
    const verifyLogin = (openid, third_type) => {
      let param = {
        timestamp: Date.parse(new Date()) / 1000,
        fun: "thirdLogin",
        requestType: "User",
        appId: state.appId,
        appKey: state.appKey,
        third_type: third_type,
        openid: openid,
      };
      var signature = getSign(param);
      var obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj)
        .then((res) => {
          afterLogin(res);
          let newUser = localStorage.getItem("newUser");
          if (newUser == null) {
            localStorage.setItem("newUser", "true");
            localStorage.setItem("firstEdit", "true");
          }
          setTimeout(() => {
            router.push("/home");
          }, 1000);
          message.success(proxy.$t(`tips.tip1`));
        })
        .catch((err) => {
          if (err.ResultCode == 401) {
            router.push({
              path: "/bindings",
              query: {
                third_type: third_type,
                openId: openid,
              },
            });
          }
        });
    };

    const accountInput = (e) => {
      clearTimeout(state.textTime);
      state.errArray.errAccount = false;
      state.textTime = setTimeout(() => {
        var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        var rel2 = /^1([3456789])\d{9}$/;
        if (e.target.value == "") {
          state.errArray.errAccount = true;
        } else if (!rel1.test(e.target.value) && !rel2.test(e.target.value)) {
          state.errArray.errAccount = true;
        } else {
          state.errArray.errAccount = false;
        }
        setTimeout(() => {
          state.errArray.errAccount = false;
        }, 1000);
        state.textTime = null;
      }, 600);
    };

    const onSubmit = () => {
      //登录
      var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      var rel2 = /^1([3456789])\d{9}$/;
      state.formRef
        .validate()
        .then(() => {
          var email = state.formState.account;
          var phone = state.formState.account;
          var password = state.formState.password;
          var timestamp = Date.parse(new Date()) / 1000;

          if (rel1.test(state.formState.account)) {
            let accountType = 2;

            let param = {
              accountType,
              appId: state.appId,
              appKey: state.appKey,
              email,
              fun: "newLogin",
              requestType: "User",
              timestamp,
              password,
            };
            var signature = getSign(param);
            var obj = JSON.parse(JSON.stringify(param));
            obj.signature = signature;
          } else if (rel2.test(state.formState.account)) {
            var accountType = 1;
            let param = {
              accountType,
              appId: state.appId,
              appKey: state.appKey,
              phone,
              fun: "newLogin",
              requestType: "User",
              timestamp,
              password,
            };
            var signature = getSign(param);
            var obj = JSON.parse(JSON.stringify(param));
            obj.signature = signature;
          } else {
            message.error(proxy.$t(`tips.tip18`));
            return;
          }
          if (state.checked) {
            axios("/api/apiservice/apiroute", obj)
              .then((res) => {
                afterLogin(res);
                let newUser = localStorage.getItem("newUser");
                if (newUser == null) {
                  localStorage.setItem("newUser", "true");
                  localStorage.setItem("firstEdit", "true");
                }
                setTimeout(() => {
                  router.push("/home");
                }, 1000);
                message.success(proxy.$t(`tips.tip1`));
              })
              .catch((err) => {});
          } else {
            message.error(proxy.$t(`tips.tip19`));
          }
        })
        .catch((error) => {
          if (
            !rel1.test(state.formState.account) &&
            !rel2.test(state.formState.account)
          ) {
            state.errArray.errAccount = true;
          }
          if (state.formState.password == "") {
            state.errArray.errPassword = true;
          }
          setTimeout(() => {
            state.errArray.errAccount = false;
            state.errArray.errPassword = false;
          }, 1000);
        });
    };
    const afterLogin = (res) => {
      let t = new Date(new Date().getTime() + 30 * 60 * 1000);
      setAuthorization({
        token: res.token,
        expireAt: new Date(t),
      });
      localStorage.setItem("userInfo", JSON.stringify(res));
    };
    const resetForm = () => {
      //重置
      state.formRef.resetFields();
      state.errArray.errAccount = false;
      state.errArray.errPassword = false;
    };
    const handleClickUrl = (value) => {
      if (value == 0) {
        router.push("/register");
      } else if (value == 1) {
        if (process.env.VUE_APP_VERSION == "hprt") {
          if (state.language == "zh") {
            window.open("/helpDetail/", "_blank");
          } else {
            window.open("/en/helpDetail/", "_blank");
          }
        } else if (process.env.VUE_APP_VERSION == "hereLabelTop") {
          window.open("/helpDetail", "_blank");
        } else {
          window.open("/help", "_blank");
        }
      } else if (value == 2) {
        if (process.env.VUE_APP_VERSION == "hprt") {
          if (state.language == "zh") {
            window.open("/download/", "_blank");
          } else {
            window.open("/en/download/", "_blank");
          }
        } else {
          window.open("/download", "_blank");
        }
      } else if (value == 3) {
        router.push("/forgetpwd");
      }
    };
    //是否勾选已阅读
    const readChange = (e) => {
      state.checked = e.target.checked;
    };
    onUnmounted(() => {
      clearInterval(state.codeTimer);
      localStorage.removeItem("code");
    });
    return {
      ...toRefs(state),
      readChange,
      handleClickUrl,
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
      onSubmit,
      resetForm,
      accountInput,
      handleMoreLogin,
      handleOpenAgreement,
    };
  },
});
</script>
<style scoped>
.beihao {
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #666;
  width: 100%;
  text-align: center;
}
a {
  color: #666;
}
.login-nav {
  width: 100%;
  height: 100%;
  background: rgba(57, 106, 193, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-main {
  width: 1200px;
  height: 704px;
  background: #ffffff;
  border-radius: 0px 4px 4px 0px;
  padding: 76px 60px 60px;
  z-index: 99;
  position: relative;
}
.left-img1 {
  position: absolute;
  width: 224px;
  height: 56px;
  display: block;
  top: 37px;
  left: 48px;
}
.here-logo {
  width: 100px;
  height: 55px;
}
.login-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-left {
  width: 50%;
  margin-top: 24px;
  height: 480px;
  background-size: 100% 100%;
}
.login-right {
  width: 50%;
  padding-left: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.login-title {
  height: 36px;
  font-size: 24px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 36px;
  margin-bottom: 32px;
}
.login-right ::v-deep(.ant-input) {
  width: 480px;
}
.login-right ::v-deep(.ant-col-14) {
  max-width: 100%;
}
.login-right ::v-deep(.ant-input-affix-wrapper) {
  width: 480px;
}
.forget-text {
  height: 30px;
  font-size: 18px;
  color: #003591;
  line-height: 26px;
  float: right;
  cursor: pointer;
}
.login-btn {
  margin-top: 32px;
}
.login-btn ::v-deep(.ant-btn) {
  width: 480px;
  height: 56px;
  font-size: 20px;
  font-weight: 500;
  line-height: 36px;
}
.check-box {
  margin-top: 24px;
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
}
.no-accout {
  height: 26px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 26px;
  margin-top: 24px;
}

.login-method {
  width: 100%;
  margin-top: 24px;
}

.method-box {
  width: 100%;
  height: 57px;
  display: flex;
  justify-content: center;
}
.method-item {
  width: 57px;
  height: 58px;
  margin: 0 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
@media only screen and (max-width: 1280px) {
  .login-main {
    width: 800px;
    height: 500px;
    padding: 51px 40px 40px;
  }
  .left-img1 {
    width: 150px;
    height: 37px;
    top: 27px;
    left: 32px;
  }
  .here-logo {
    width: 66px;
    height: 36px;
  }
  .login-left {
    margin-top: 16px;
    height: 320px;
  }
  .login-right {
    padding-left: 40px;
  }
  .login-title {
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 21px;
  }
  .login-right ::v-deep(.ant-input) {
    width: 320px;
  }

  .login-right ::v-deep(.ant-input-affix-wrapper) {
    width: 320px;
  }

  .forget-text {
    height: 20px;
    font-size: 12px;
    line-height: 20px;
  }
  .login-btn {
    margin-top: 21px;
  }
  .login-btn ::v-deep(.ant-btn) {
    width: 320px;
    height: 37px;
    font-size: 14px;
    line-height: 24px;
  }
  .check-box {
    margin-top: 16px;
    font-size: 12px;
    line-height: 16px;
  }
  .no-accout {
    height: 17px;
    font-size: 12px;
    line-height: 17px;
    margin-top: 16px;
  }
  .login-method {
    width: 100%;
    margin-top: 25px;
  }
  .method-box {
    height: 38px;
  }
  .method-item {
    width: 38px;
    height: 39px;
  }
}
</style>
